import { Helmet } from 'react-helmet-async';

const StructuredData = ({ data }) => (
	<Helmet>
		<script type="application/ld+json">
			{JSON.stringify(data)}
		</script>
	</Helmet>
);

export default StructuredData;
